<script setup>
import { ref, computed, watch } from 'vue';
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';
import FormField from '@/components/FormField.vue';
import { isEmail } from '@/common/validators';

const props = defineProps({
  visible: Boolean,
  loading: Boolean,
});

const emit = defineEmits(['close', 'success']);

const email = ref('');
const confirmEmail = ref('');

const isEmailsMatch = computed(() => email.value === confirmEmail.value);
const isButtonDisabled = computed(
  () => !isEmail(email.value) || !isEmailsMatch.value
);

const onInput = (e, field) => {
  if (field === 'email') email.value = e.target.value;
  if (field === 'confirmEmail') confirmEmail.value = e.target.value;
};

const handleSubmit = () => {
  if (!isButtonDisabled.value) {
    emit('success', { email: email.value });
  }
};

watch(
  () => props.visible,
  () => {
    email.value = '';
    confirmEmail.value = '';
  },
  { immediate: true }
);
</script>

<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="emit('close')"
  >
    <div class="flex justify-center">
      <div class="relative rounded bg-white p-4">
        <section class="mb-4 flex items-center justify-between">
          <h3 class="text-left text-base text-dark-gray">Invite Owner(s)</h3>
          <svg
            class="cursor-pointer"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            @click="emit('close')"
          >
            <path
              d="M18.364 7.05044L16.9498 5.63623L12 10.586L7.05026 5.63623L5.63605 7.05044L10.5858 12.0002L5.63605 16.9499L7.05026 18.3642L12 13.4144L16.9498 18.3642L18.364 16.9499L13.4142 12.0002L18.364 7.05044Z"
              fill="#6C7C9D"
            />
          </svg>
        </section>
        <p class="text-left text-sm font-normal text-neutral-subtle">
          Enter the owner’s email address to invite them to Highway.
        </p>

        <form-field
          label="Email"
          :value="email"
          placeholder="Enter email address"
          :on-input="(e) => onInput(e, 'email')"
          name="email"
        />

        <form-field
          label="Re-enter Email"
          :value="confirmEmail"
          placeholder="Confirm email address"
          :on-input="(e) => onInput(e, 'confirmEmail')"
          name="confirmEmail"
        />
        <section class="mt-4 flex gap-3">
          <button-main
            variant="secondary"
            @click="emit('close')"
          >
            Go Back
          </button-main>
          <button-main
            :disabled="isButtonDisabled"
            :loading-spinner="loading"
            @click="handleSubmit"
          >
            Invite Contact
          </button-main>
        </section>
      </div>
    </div>
  </modal>
</template>
